/*
 * Pure helpers over the API's per-day rows, kept out of the panel so they can
 * be tested without rendering a chart.
 */

/* How close to full before a day's tile is flagged amber. */
export const WARNING_HEADROOM = 5;

/**
 * Is there a capacity to measure against?
 *
 * A lot with no capacity set, or a property with its inventory limit switched
 * off, has nothing to be full against - so the panel drops its capacity line,
 * its fill bars and the "/ N" tails rather than dividing by nothing.
 */
export function hasCapacity(capacity) {
  return typeof capacity === "number" && capacity > 0;
}
